import styled, {css} from 'styled-components'
import {ChevronIcon} from '../../../../assets/icons/ChevronIcon'

const StyledToolbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const StyledHeading = styled.p`
    ${({theme: {typography, palette}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral.black};
        text-transform: capitalize;
    `}
`

const StyledNavBar = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 4}px;
    `}
`

const StyledTodaySpan = styled.span`
    ${({theme: {typography, palette}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral.black};
        text-decoration: underline;
    `}
`

const StyledChevronIcon = styled(ChevronIcon)`
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
`

export {StyledToolbar, StyledHeading, StyledNavBar, StyledTodaySpan, StyledChevronIcon}
